import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { VerificationPartner } from '../../../models/VerificationPartner';
import { VerificationPackageCheckType } from '../../../models/VerificationCheckType';

@Component({
  selector: 'app-check-type-dialog',
  templateUrl: './check-type-dialog.component.html',
  styleUrls: ['./check-type-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatExpansionModule,
    MatDialogModule
  ]
})
export class CheckTypeDialogComponent implements OnInit {

  form!: FormGroup;
  partners!: VerificationPartner[];
  checkTypes!: VerificationPackageCheckType[];
  verificationCheckTypes: VerificationPackageCheckType[] = [];
  availablePartnerCheckTypes: VerificationPackageCheckType[] = [];
  noAvailableCheckTypes: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CheckTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initForm();
    this.partners = this.data.partners;
    this.checkTypes = this.data.checkTypes;
    this.verificationCheckTypes = this.data.verificationCheckTypes;
  }

  initForm() {
    this.form = this.formBuilder.group({
      partner_id: ['', Validators.required],
      check_types: ['', Validators.required]
    });
  }

  sortByPartner(partnerId: any) {
    this.availablePartnerCheckTypes = [];

    const partner = this.partners.find(partner => partner.id === partnerId);
    if (partner && partner.check_types.length > 0) {
      let partnerCheckTypes = this.checkTypes.filter(o => partner.check_types.find((o2: any) => o.id === o2.verification_check_type_id));

      this.availablePartnerCheckTypes = partnerCheckTypes.filter(o => !this.verificationCheckTypes.find((o2: any) => o.id === o2.verification_check_type_id));
      if (this.availablePartnerCheckTypes.length > 0) {
        this.noAvailableCheckTypes = false;
      } else {
        this.noAvailableCheckTypes = true;
      }
    } else {
      this.noAvailableCheckTypes = true;
    }
  }

  submitCheckType() {
    let payload = {
      partner_id: this.form.get('partner_id')?.value,
      check_types: this.form.get('check_types')?.value
    }
    this.dialogRef.close(payload);
  }

  canCreateCheckType(): boolean {
    return (
      this.form.valid
    );
  }
}